import { createAction, props } from '@ngrx/store';
import { ContactCustomerAndSupplierModel } from '@shared/data-access/models';

export const getDetail = createAction('[CUSTOMER LISTING] GET DETAIL', props<{ item: ContactCustomerAndSupplierModel }>());

export const createOrUpdate = createAction('[CUSTOMER LISTING] SAVE CUSTOMER');
